import script from "./two-column-layout.vue?vue&type=script&setup=true&lang=ts"
export * from "./two-column-layout.vue?vue&type=script&setup=true&lang=ts"

const __exports__ = script;

export default __exports__